import { motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function PrivacyPage() {
  // Check if user is B2B (from localStorage)
  const isB2B = localStorage.getItem("cliptour_isB2B") === "true";
  const homePath = isB2B ? "/partners" : "/";
  
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <Header homePath={homePath} />

      <section className="section-spacing pt-32">
        <div className="container-custom">
          <motion.div 
            className="max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl font-bold text-slate-900 mb-8">Privacy Policy</h1>
            <p className="text-slate-500 mb-8">Last updated: {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</p>

            <div className="prose prose-slate max-w-none">
              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">1. Introduction</h2>
              <p className="text-slate-600 mb-4">
                Cliptour ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services at cliptour.ai.
              </p>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">2. Information We Collect</h2>
              <p className="text-slate-600 mb-4">We collect information you provide directly to us, including:</p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
                <li>Name and email address</li>
                <li>Company name (optional)</li>
                <li>Payment information (processed securely through Stripe)</li>
                <li>Property photos and media files you upload</li>
                <li>Communications you send to us</li>
              </ul>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">3. How We Use Your Information</h2>
              <p className="text-slate-600 mb-4">We use the information we collect to:</p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
                <li>Process and fulfill your orders</li>
                <li>Send you order confirmations and updates</li>
                <li>Respond to your inquiries and provide customer support</li>
                <li>Improve our services and develop new features</li>
                <li>Comply with legal obligations</li>
              </ul>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">4. Data Security</h2>
              <p className="text-slate-600 mb-4">
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. All payment transactions are processed through Stripe's secure payment infrastructure.
              </p>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">5. Data Retention</h2>
              <p className="text-slate-600 mb-4">
                We retain your personal information for as long as necessary to fulfill the purposes for which it was collected, including to satisfy legal, accounting, or reporting requirements. Uploaded photos and videos are retained for 90 days after order completion.
              </p>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">6. Third-Party Services</h2>
              <p className="text-slate-600 mb-4">
                We may use third-party services that collect, monitor, and analyze data, including:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
                <li>Stripe for payment processing</li>
                <li>Cloud storage providers for file hosting</li>
                <li>Email service providers for communications</li>
              </ul>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">7. Your Rights</h2>
              <p className="text-slate-600 mb-4">You have the right to:</p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt-out of marketing communications</li>
              </ul>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">8. Contact Us</h2>
              <p className="text-slate-600 mb-4">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <p className="text-slate-600">
                Email: <a href="mailto:contact@cliptour.ai" className="text-#3C59B2 hover:underline">contact@cliptour.ai</a>
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
